<template>
  <div ref="login_mailaddress">
    <form class="authForm u-pd-r-1 u-pd-l-1"
    v-show="showLoginForm"
    :data-loading="isLoading"
    :data-regist="regist === '1'"
    ref="loginForm"
    novalidate="true"
    @submit.prevent="login($event)"
    :action="action"
    method="POST">
    <div class="authForm__backDrop" v-if="isLoading"></div>
    <app-loading class="authForm__loading" :isLoading="isLoading"></app-loading>
    <div class="authForm__body u-mg-b-4">
      <input type="hidden" name="reissue_key" :value="reissueKey">
      <input type="hidden" name="return_path" :value="returnPath">

      <input type="hidden" name="id" :value="email">
      <input type="hidden" name="_token" :value="token">

      <div
      class="alert"
      data-color="error"
      v-if="errorMessage"
      v-html="errorMessage"
      >
      {{ errorMessage }}
    </div>

    <form-input
    v-model="email"
    type="email"
    name="email"
    placeholder="半角英数字で入力してください"
    label="メールアドレス"
    :validation="{ rules: {
      required: true,
      nonRfcEmailCheck: true,
      email: false
      } }"
      ></form-input>

      <form-password
      v-model="password"
      name="password"
      placeholder="半角英数字で入力してください"
      label="パスワード"
      :autosave="false"
      :validation="{ rules: {
        required: true
        } }"
        :strength-meter="false"
        ></form-password>
        <div class="u-tx-right" >
          <small><a href="/user/password">パスワードを忘れた方
            <img src="/static/img/simplearrow-right-gray.svg" class="arrow-right"></img>
          </a></small>
        </div>
      </div>
      <div>
        <button type="button" @click="login()" class="btn"
        data-color="brand"
        data-block="true"
        >ログイン</button>
      </div>
    </form>

    <!-- フォーム表示用 -->
    <div class="u-pd-r-1 u-pd-l-1 u-mg-b-3" v-if="!showLoginForm">
      <button type="button" @click="clickShowForm" class="btn"
      data-color="brand"
      data-block="true"
      >メールアドレスでログイン</button>

      <div class="u-mg-t-3" v-if="!showLoginForm">
        <!-- SNS認証 -->
        <sns-register register-type="signin"
        :registToken="registToken"
        ></sns-register>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import login from './login'

export default {
  name: 'login-form',
  mixins: [login],
  data() {
    return {
      showLoginForm: false,
    }
  },
  props: {
    registToken: { type: String, default: ''},
    fromPage: { type: String, default: '' }
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.data
    })
  },
  watch:{
    authUser() {
      if(this.fromPage==null && this.authUser.is_registed){
        this.showLoginForm = true
      }
    }
  },
  methods: {
    clickShowForm() {
      this.showLoginForm = true;
    }
  },
  mounted() {
    this.showLoginForm = this.authUser.is_registed
    this.email = this.authUser.email
  }
}</script>

<style lang="scss">
.authForm {
  position: relative;
  overflow: hidden;

  &__loading {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__backDrop {
    position: absolute;
    top: 0;
    left: 0;
    right :0;
    bottom: 0;
    z-index: 2;
  }
  &[data-loading='true'] {
    pointer-events: none;
  }
  &[data-regist='true'] {
    .authForm {
      &__body, &__footer {
        visibility: hidden;
      }
    }
  }
  .arrow-right {
    vertical-align: middle;
    margin-top: -1px;
    margin-left: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LoginForm.vue